import { lazy, Suspense } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import MarqueeStrip from "../components/MarqueeStrip";
import ValueStrip from "../components/ValueStrip";
import Footer from "../components/Footer";
import StickyBuyBar from "../components/StickyBuyBar";
import CartDrawer from "../components/CartDrawer";

/* Everything below the first screens loads on demand — the first paint only
   carries the hero, so the store opens fast even on slow mobile connections. */
const BentoGrid = lazy(() => import("../components/BentoGrid"));
const MediaGallery = lazy(() => import("../components/MediaGallery"));
const StatsBand = lazy(() => import("../components/StatsBand"));
const VideoWidget = lazy(() => import("../components/VideoWidget"));
const CommunityMarquee = lazy(() => import("../components/CommunityMarquee"));
const TrackOrderBand = lazy(() => import("../components/TrackOrderBand"));
const ReviewsSection = lazy(() => import("../components/ReviewsSection"));
const FaqSection = lazy(() => import("../components/FaqSection"));
const FinalCTA = lazy(() => import("../components/FinalCTA"));

export default function LandingPage() {
  return (
    <div className="relative overflow-x-clip bg-oat-50 text-charcoal-900">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <ValueStrip />
        <Suspense
          fallback={
            <div className="mx-auto flex max-w-7xl items-center justify-center py-24" aria-hidden="true">
              <span className="h-8 w-8 animate-spin rounded-full border-2 border-sage-500 border-t-transparent" />
            </div>
          }
        >
          <BentoGrid />
          <MediaGallery />
          <StatsBand />
          <VideoWidget />
          <CommunityMarquee />
          <TrackOrderBand />
          <ReviewsSection />
          <FaqSection />
          <FinalCTA />
        </Suspense>
      </main>
      <Footer />
      <StickyBuyBar />
      <CartDrawer />
    </div>
  );
}
